<template>
    <div class="card col-12 p-2 p-lg-3">
        <div class="d-flex mb-4">
            <div class="btn-group" role="group" aria-label="Basic radio toggle button group">
                <input type="radio" class="btn-check" name="btnradio" id="btnradio1" autocomplete="off" checked @click="change_date_type(0)">
                <label class="btn btn-outline-primary" for="btnradio1">即時</label>
                <input type="radio" class="btn-check" name="btnradio" id="btnradio2" autocomplete="off" @click="change_date_type(1)">
                <label class="btn btn-outline-primary" for="btnradio2">歷史</label>
            </div>
            <button class="ms-auto btn btn-warning" @click="export_csv()">CSV</button>
        </div>
        <div id="plot1_div" style="position: relative;"></div>
        <div class="row g-0">
            <div class="col-12 col-md-7 col-lg-8 col-xl-8 text-center">
                <md-field>
                    <label for="plant_select">選擇案場</label>
                    <md-select v-model="plant_select" name="plant_select">
                        <md-option v-for="(plant_data, pv_plant_ID) in plant_information" v-bind:key="pv_plant_ID" :value="pv_plant_ID">{{plant_data["name"]}}</md-option>
                    </md-select>
                </md-field>
            </div>
            <div class="col-12 col-lg-9 col-xl-9 col-xxl-10 mb-2" v-if="date_type == 1">
                <label>搜尋區間</label>
                <date-picker class="col-12 col-md-9 col-lg-9 col-xl-8 col-xxl-7" v-model="date1" type="date" 
                value-type="format" format="YYYY-MM-DD"
                placeholder="請選擇搜尋時間" :clearable="false" @change="search()"
                :disabled-date="(date) => date >= new Date()"></date-picker>
            </div>
            
        </div>
    </div>
</template>
<script>
import DatePicker from "vue2-datepicker"
import "vue2-datepicker/index.css"
import "vue2-datepicker/locale/zh-tw"
import moment from "moment"
import Plotly from "plotly.js"

export default{
    components:{
        DatePicker
    },
    data(){
        return {
            date1: moment().format('YYYY-MM-DD'),
            date_range: 1,
            date_type: 0,
            plot_type: "scatter", 
            plant_information: {},
            plant_select: null,
            dict1: {},
               
        }
    },
    methods:{
        search(){
            let that = this
            if(this.plant_select == null){
                alert('請選擇案場')
                return false
            }
            this.axios.get('/pv_kw_kwp_inv_plot', {
                params:{
                    pv_plant_ID: this.plant_select,
                    datepicker: this.date1
                }
            }).then(function(data){
                console.log(data.data.data)
                let alldata =  data.data.data
                that.dict1 = alldata
                let x_data = alldata['x_axis'].slice(420, 1139)
                let y_data = alldata['y_axis']
                let z_data = alldata['z_axis']
                for(var i in z_data){
                    z_data[i] = z_data[i].slice(420, 1139)
                }
                //console.log(y_data, z_data)
                let plot_data = [
                    {
                    z: z_data,
                    x: x_data,
                    y: y_data,
                    zmin: 0,
                    zmax: 1,
                    colorscale: [
                        ["0.0", "blue"],
                        ["0.6", "orange"],
                        ["1.0", "red"],
                    ],
                    type: "heatmap",
                    ygap: 0.5
                    },
                ]
                //console.log($("#plot_div").width() - 100)
                let layout = {
                    width: document.getElementById('plot1_div').clientWidth,
                    height:document.getElementById('plot1_div').clientHeight,
                    margin: that.plot_margin(),
                    title: {
                        text: `${that.plant_information[that.plant_select]['name']} ${that.date1}`,
                        font: {
                            family: "Courier New, monospace",
                            size: 24,
                        },
                    },
                }
                console.log(plot_data)
                Plotly.newPlot("plot1_div", plot_data, layout, {
                    displaylogo: false,
                    modeBarButtonsToRemove: [
                    "sendDataToCloud",
                    "hoverClosestCartesian",
                    "hoverCompareCartesian",
                    "toggleSpikelines",
                    ],
                })

            })
        },
        export_csv(){
            let alldata = this.dict1
            let keys = Object.keys(alldata)
            if(keys.length === 0){
                alert("無資料")
                return false
            }
            let data_length = alldata['x_axis'].length // Using length og first element as reference
            var header = "time"
            for(var ii in alldata['y_axis']){
                header += (','+alldata['y_axis'][ii])
            }
            header += "\n"
            var str1 = ""
            for(var i=0; i<data_length; i+=1){
                str1 += alldata['x_axis'][i]
                for(var ii in alldata['z_axis']){
                    str1 += `,${alldata['z_axis'][ii][i]}`
                }
                str1 += '\n'
            }
            //Export CSV
            let csv_data = header + str1
            var fileName = "Inv發電熱流圖_"+this.date1+this.plant_information[this.plant_select]['name']
            +".csv";//匯出的檔名
            var blob = new Blob(["\ufeff",csv_data], {
                type : "application/octet-stream"
            })
            var href = URL.createObjectURL(blob)
            var link = document.createElement("a")
            document.body.appendChild(link)
            link.href = href
            link.download = fileName
            link.click()
                    
        },
        change_date_type(type){
            this.date_type = type
            if(type == 0){
                this.date1 = moment().format('YYYY-MM-DD')
            }
            this.search()
        },
        plot_resize(){
            let update = {
                width: "",
                heigth: "",
            }
            update = {
                width: document.getElementById('plot1_div').clientWidth,
                height:  document.getElementById('plot1_div').clientHeight,
                margin: this.plot_margin(),
                legend: this.get_legend()
            }
            Plotly.relayout("plot1_div", update)
        },
        get_legend(){
            if(document.getElementById('plot1_div').clientWidth < 992){
                return   {"x": 0, "y": -1}
            }else{
                return {"x": 0, "y": 1}
            }
            
        },
        plot_margin(){
            let margin =  {
                l: 140,
                r: 50,
                b: 40,
                t: 50,
                pad: 4,
            }
            if(document.getElementById('plot1_div').clientWidth < 992){
                margin.l = 140
                margin.r = 1
                margin.b = 40
                margin.pad = 0
            }
            return margin
        },
    },
    mounted(){
        let that = this
        this.axios.get("/pv_plant_information")
        .then(function (data) {
            // 帶入params
            that.plant_information = {}
            for(var i in data.data.information){
                if(['屏東佳冬段', '花蓮綜開段', '台南七股段'].includes(data.data.information[i]['name'])){
                    continue
                }
                that.plant_information[data.data.information[i]['_id']] = data.data.information[i]
                that.plant_select = data.data.information[i]['_id']
            }
            //console.log(that.plant_information)
        })
        window.addEventListener("resize", this.plot_resize)
    },
    watch:{
        plant_select: function(val){
            if(val == null || val == ''){
                alert('請選擇案場')
                return false
            }
            this.search()
        }
    },
    destroyed(){
        window.removeEventListener("resize", this.plot_resize)
    },
}
</script>
<style scoped>
#plot1_div{
    min-height: 60vh;
}
@media(max-width: 991px){
    #plot1_div{
        min-height: 120vh;
    }
}
</style>
